import axios from 'axios';
import API from 'lib/RemindAPI';
import FileEntity from 'entities/File';
import * as actions from 'reducers/fileUploads';
import { Backbone$Id } from 'types/typescript/Backbone';

function buildForm(fields: [string, string], blob: File) {
  const form = new FormData();
  const entries: [string, string][] = Object.entries(fields);
  entries.forEach(pair => form.append(...pair));
  form.append('file', blob);
  return form;
}

export async function uploadFileRequest(
  fileContextKey: string,
  fileKey: Backbone$Id,
  blob: File,
  privateUpload: boolean = false
): Promise<FileEntity> {
  // Fetch file upload address and fields from api
  const fileName = blob.name;
  const postParamsPromise = API.request('/files', 'POST', {
    file: {
      name: fileName,
    },
    private: privateUpload,
  });

  const postParams = await postParamsPromise;
  const uploadUrl = postParams.upload_url;

  // Upload file to CDN
  await axios.post(uploadUrl, buildForm(postParams.fields, blob), {
    onUploadProgress: progressEvent => {
      const progressPercentage = (progressEvent.loaded / progressEvent.total) * 100;
      actions.progressUpdate(fileContextKey, fileKey, progressPercentage);
    },
  });

  // Load file entity
  const fileId = postParams.id;
  const fileAckData = await API.request(`/files/${fileId}/ack`, 'POST');

  return FileEntity.fromJSON(fileAckData);
}

// DEPRECATED: try not to use this since it returns a backbone entity.
// use fetchJSONFileByIdRequest instead, which returns a `V2File`
export async function fetchFileByIdRequest(fileId: Backbone$Id): Promise<FileEntity> {
  const fileResponse = await API.request(`/files/${fileId}`, 'GET');
  return FileEntity.fromJSON(fileResponse);
}

export type V2File = {
  content_type: string;
  id: string;
  name: string;
  preview_height: number;
  preview_width: number;
  size: number;
  urls: { cdn: string | null; tracked: string | null };
  view_count: number;
  viewers: any[];
};

export async function fetchJSONFileByIdRequest(fileId: Backbone$Id): Promise<V2File> {
  const fileResponse = await API.request(`/files/${fileId}`, 'GET');
  return fileResponse;
}
